<template>
  <b-form-group :label="label" class="mr-2">
    <date-range-picker
      ref="dateRangePicker"
      v-model="valuesObj"
      :showDropdowns="true"
      :autoApply="true"
      :linkedCalendars="false"
      @update="updateDateRangeValues"
      style="min-width: 230px;"
    >
      <template v-slot:input="{ startDate, endDate }">
        {{ startDate | date }} - {{ endDate | date }}
      </template>
      <template v-slot:ranges="{ startDate, endDate, ranges }">
        <div class="ranges col-12 col-md-auto">
          <ul>
            <li
              v-for="(value, name, index) in ranges"
              :key="index"
              @click="setDateRanges(value)"
            >
              {{ name }}
            </li>
            <li @click="setDateRangeAll(true)">All</li>
          </ul>
        </div>
      </template>
    </date-range-picker>
  </b-form-group>
</template>

<script>
  import moment from 'moment';
  import DateRangePicker from 'vue2-daterange-picker';
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
  export default {
    components: {
      DateRangePicker,
    },
    props: {
      label: {
        type: String,
        default: 'Date Range',
      }, dateFrom: {
        type: String,
        default: '',
      }, dateTo: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        valuesObj: {
          startDate: this.dateFrom,
          endDate: this.dateTo,
        },
      };
    },
    // computed: {
    //   valuesObj(){
    //     return {startDate: this.dateFrom, endDate: this.dateTo};
    //   }
    // },
    methods: {
      updateDateRangeValues(values) {
        this.$emit('handleSearch', {
          dateFrom: (values.startDate) ? moment(values.startDate).format('MM-DD-YYYY') : null,
          dateTo: (values.endDate) ? moment(values.endDate).format('MM-DD-YYYY') : null,
        });
      },
      setDateRanges(value) {
        this.$refs.dateRangePicker.clickRange(value);
      },
      setDateRangeAll(clear = false) {
        this.valuesObj.startDate = '';
        this.valuesObj.endDate = '';
        this.$refs.dateRangePicker.togglePicker(false, true);
        if(clear){this.updateDateRangeValues({})}
      },
    },
    watch: {
      dateFrom(newDate) {
        if (!newDate) {
          this.setDateRangeAll();
        }else if (newDate !== null) {
          this.valuesObj.startDate = this.dateFrom;
        }
      },
      dateTo(newDate) {
        if (!newDate) {
          this.setDateRangeAll();
        }else if (newDate !== null) {
          this.valuesObj.endDate = this.dateTo;
        }
      },
    },
    filters: {
      date(value) {
        if (!value) return '';
        let options = { year: 'numeric', month: 'long', day: 'numeric' };
        return Intl.DateTimeFormat('en-US', options).format(value);
      },
    },
  };
</script>

<style>
  .daterangepicker {
    width: 637px !important;
  }
</style>
